export const isLessThan24HourAgo = () => {
  const loginTime = localStorage.getItem('loginTime');
  if (loginTime) {
    const oneDay = parseInt(loginTime) + 24 * 60 * 60 * 1000;
    return oneDay > new Date().getTime();
  }
  return false;
};
